import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

function readPreference(): boolean {
  try {
    return window.matchMedia(REDUCED_MOTION_QUERY).matches;
  } catch {
    return false;
  }
}

/**
 * 追蹤 `prefers-reduced-motion`（spec 23.3）。
 *
 * index.css 已經把 CSS transition 與 animation 統一壓到 0.01ms，
 * 但用 JavaScript 排程的持續動畫（例如樹懶待機換格）CSS 管不到，
 * 必須由元件自己停下來，所以才需要這個 hook。
 */
export function usePrefersReducedMotion(): boolean {
  const [reduced, setReduced] = useState(readPreference);

  useEffect(() => {
    let media: MediaQueryList;
    try {
      media = window.matchMedia(REDUCED_MOTION_QUERY);
    } catch {
      return;
    }
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    media.addEventListener?.('change', onChange);
    return () => media.removeEventListener?.('change', onChange);
  }, []);

  return reduced;
}
